
import React, {Component} from 'react';
import ReactTree from './ReactTree';
import { FormControl,Button } from 'react-bootstrap'
import 'jstree/dist/themes/default/style.min.css';
import 'jstree/dist/themes/default-dark/style.min.css';
import { select } from 'react-date-picker/lib/DecadeView';
import QuotationDocModal from './QuotationDocModal'
import QOFileStore from '../../stores/QOFileStore'
import {directoryHelper} from '../../utils/helpers'
const CORE = {
  "check_callback" : true,  
  //data: [{"text":"dir1","children":[{"text":"dir1.1","children":[{"text":"jstree.json","icon":"jstree-file","is_file":true}]},{"text":"dir2.1","children":[{"text":"dir2.1.1","children":[]}]}]},{"text":"dir2","children":[]},{"text":"jstree.json","icon":"jstree-file","is_file":true}]
  //data : [{      "text": "All Categories ","children": [{          "text": "For Sale",}]}]
  data:[]
  // 'data' : {
  //   'url' : "https://api.bigfix.co/demo2/public/workdoc/folder_structure",
  //   'data' : function (node) {
  //       //console.log('node',node)
  //       return { 'id' : node.id };
  //   }
  // }
}
class QuotationFileTreePage extends Component {

  constructor(props){
    super(props);
    this.state = {loading:true,postingQ:[],posting:false,value:'',data:CORE,template:{},items:[],showQo:false,fileId:'',fileName:''};
    this.clickCount = 0;
    this.singleClickTimer = null;
  }

  componentDidMount(){
    let {data} = this.state
    let that = this
    QOFileStore.loadFolderStucture('qo',function(result){
      data.data = [result.trash,result.data]//[{"id" : "0","text":"ใบเสนอราคาทั้งหมด","state" : {"opened" : true},"children":result.data}]
      //data.data = directoryHelper.walk_dirid(data.data[0],0);
      let template = result.template.map((item,index)=>{

        return {id:item.template_id,label:item.name,icon:'fa fa-file'}
      })
      // let template = {
      //   tmp1:{id:'tmp1',label:'Template 1',icon:'fa fa-file',action:function(obj){
      //     console.log('Template',obj)
      //   }}}
      console.log('data',data,template)
      that.setState({data:data,template:template,loading:false})
    },function(err){
      that.setState({loading:false})
    })
  }

  saveFolderStructure(savedData){
    
    let that = this ,data = {data:[]}
    data.data = [{"id" : "0","text":"ใบเสนอราคาทั้งหมด 123","state" : {"opened" : true},"children":savedData}]
    //this.setState({loading:true,data:data})
    window.setTimeout(function(){
      //that.setState({loading:false})      
    },100)
    // QOFileStore.saveFolderStructure('qo',savedData,function(result){
      
    //   that.setState({loading:false})
    // },function(err){
    //   that.setState({loading:false})
    // })
  }

  saveFolderStructureChange(action,targetId,srcFile=null){
    let {posting,postingQ} = this.state
    let postData = {action:action,targetId:targetId,srcFile:srcFile}
      
    let that = this
    if(posting){
      postingQ.push(postData)  
      this.setState({postingQ:postingQ})
      // setTimeout(function() {
      //   that.saveFolderStructureChange(action,targetId,srcFile)
      // }, 200);
    }else{      
      this.setState({posting:true})
      QOFileStore.saveFolderStructureChange('qo',postData,function(result){        
        let {postingQ} = that.state
        if(postingQ.length>0){
          postData = postingQ.pop()
          that.setState({posting:false,postingQ:postingQ})                        
          that.saveFolderStructureChange(postData.action,postData.targetId,postData.srcFile)
        }else{
          that.setState({posting:false})
        }
      },function(err){          
        that.setState({posting:false})
      })
    }
  }

  onTemplateSelect(obj,nodeData,instance){
    console.log('onTemplateSelect',obj,nodeData,instance)
    //nodeData.instance.create_node(nodeData.node,newText)  
    instance.create_node( nodeData.id, {template_id:obj.item.id , "text":'New File.xls',is_file:true,icon:'jstree-file' }, 'first', false, false);	
    //this.saveFolderStructureChange('create.template',nodeData.node.parent,{id:nodeData.node.id,text:nodeData.node.text,children:[]})
  }

  onFolderChange(newData){
    console.log('folder',newData)
    //this.setState({items:newData})
  }

  onChange(value){
    this.setState({value:value})
  }

  onClick(){
    let {data} = this.state
    data['data'] = [{      
      "text": "All Categories ",
      "children": [
        {          
          "text": "For Sale",
        }
      ]
    }]
    this.setState({data:data})
  }


  onCreateNode(nodeData){
    console.log('onCreateNode',nodeData)
    if(nodeData.node.original.is_file!==undefined && nodeData.node.original.is_file){
      this.saveFolderStructureChange('create.node',nodeData.node.parent,{template_id:nodeData.node.original.template_id,id:nodeData.node.id,text:nodeData.node.text,is_file:true,icon:'jstree-file'})
    }else{
      this.saveFolderStructureChange('create.node',nodeData.node.parent,{id:nodeData.node.id,text:nodeData.node.text,children:[]})
    }
  }

  onDeleteNode(nodeData){
    console.log('onDelete',nodeData)

    if(nodeData.parent==='trash'){
      this.saveFolderStructureChange('deleteforever',nodeData.node.id)
    }else{
      let is_file = (nodeData.node.original.icon!==undefined && nodeData.node.original.icon==='jstree-file')
      this.saveFolderStructureChange('remove',nodeData.node.id,{id:nodeData.node.id,is_file:is_file})

      nodeData.instance.move_node(nodeData.node,"trash")
    }
  }

  onDeleteForever(obj,nodeData,instance){
    instance.delete_node( nodeData.id);	
    
  }

  onRenameNode(nodeData){
    console.log('onRenameNode',nodeData)
    let srcFile = Object.assign(nodeData.node.original,{text:nodeData.text})
    this.saveFolderStructureChange('rename',nodeData.node.id,srcFile)
  }

  onNewWork(e,data){
    console.log('onNewWork',e,data)
  }

  onMoveNode(nodeData){
    console.log('onMoveNode',nodeData)
    if(nodeData.node.parent!=='trash'){
      this.saveFolderStructureChange('move',nodeData.node.parent,nodeData.node.original)
    }
    
  }

  onCopyNode(nodeData){
    console.log('onCopyNode',nodeData)
    let newText = nodeData.node.text
    let newFile = {original_id: nodeData.original.id,id:nodeData.node.id,text:newText}
    if(nodeData.original.original.is_file){
      let n = newText.lastIndexOf(".")
      if(n>0){
        let newStr = newText.substring(0,n)
        newText = newStr+' copy'+newText.substring(n)
        nodeData.new_instance.rename_node(nodeData.node,newText)          
      }      
      newFile = {original_id: nodeData.original.id,id:nodeData.node.id,text:newText,is_file:true,icon:'jstree-file'}
    }else{
      newText = newText+' copy'
      nodeData.new_instance.rename_node(nodeData.node,newText)    
      newFile = {original_id: nodeData.original.id,id:nodeData.node.id,text:newText,children:[]}
    }
    
    this.saveFolderStructureChange('paste',nodeData.node.parent,newFile)


    
  }

  onOpenNode(nodeData){
    console.log('onOpenNode',nodeData)
    //nodeData.node.original['opened'] = true
    let {data} = this.state

    //data.data = directoryHelper.walk_action(data.data,'open',nodeData.node.id)

    this.saveFolderStructureChange('open',nodeData.node.id)
  }

  onCloseNode(nodeData){
    let {data} = this.state

    this.saveFolderStructureChange('close',nodeData.node.id)
  }

  onDoubleClick(e,selected,event){
    console.log('onDoubleClick',e,selected,event)
    if((e.original.is_file !==undefined && e.original.is_file)|| e.children==undefined){
      this.setState({showQo:true,fileId:e.id,fileName:e.text})
    }
  }

  onSelect(e,selected,event){
    if(selected.length>1){
      return
    }
    
    let that = this
    this.clickCount++;
    console.log('onSelect',e,selected,this.clickCount)
    if (this.clickCount === 1) {
        this.singleClickTimer = setTimeout(function() {
          that.clickCount = 0;
          
            //singleClick();
            //console.log('clear click',clickCount)
        }, 400);
        
    } else if (this.clickCount >= 2 ) {
        this.clickCount = 0
        clearTimeout(this.singleClickTimer);            
        this.onDoubleClick(e,selected,event);
    }
  }

  onCopy(data){
    console.log('onCopy',data)
    //data.node
    //data.instance.rename(data.node)
    //let instance = this.refs['react-tree'].getInstance();
//    let instance = data.instance
//    let node = instance.get_node("0_0", false);
//    console.log('instance',instance,node)
  }



  onPaste(nodeData){
    let {data} = this.state
    console.log('onPaste',data,nodeData)  
    
    nodeData.instance.open_node(nodeData.parent)          
        
  }

  renderTreeView(){
    let {loading,data,template} = this.state

    if(loading){
      return (<span>กำลังดึงข้อมูล...</span>)
    }

    
    return (<ReactTree 
      ref='react-tree'
      core={data} 
      template={template}
      onCreateNode={this.onCreateNode.bind(this)}
      onRenameNode={this.onRenameNode.bind(this)}
      onNewWork={this.onNewWork.bind(this)}
      onDeleteNode={this.onDeleteNode.bind(this)}
      onCopyNode={this.onCopyNode.bind(this)}
      onMoveNode={this.onMoveNode.bind(this)}
      onOpenNode={this.onOpenNode.bind(this)}
      onCloseNode={this.onCloseNode.bind(this)}
      onSelect={this.onSelect.bind(this)}
      onCopy={this.onCopy.bind(this)}
      onPaste={this.onPaste.bind(this)}
      onDeleteForever={this.onDeleteForever.bind(this)}
      onTemplateSelect={this.onTemplateSelect.bind(this)}
      onChanged={this.onFolderChange.bind(this)} />)
  }
  
  render(){
      let {value,data,showQo,fileId,fileName} = this.state
  
      return (
        <div>
          <div>
            {this.renderTreeView()}
            <QuotationDocModal 
            show={showQo} 
            fileId={fileId}
            fileName={fileName}
            onHide={()=>{this.setState({showQo:false})}}/>
          </div>
        </div>
      );
  }
}


export default QuotationFileTreePage;





// WEBPACK FOOTER //
// ./src/view/qo/QuotationFileTreePage.js